"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.PimSync.Hotfile.Api
 * API for Hotfile handling
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotfileStateToJSON = exports.HotfileStateFromJSONTyped = exports.HotfileStateFromJSON = exports.HotfileState = void 0;
/**
 *
 * @export
 */
exports.HotfileState = {
    None: 0,
    Pending: 1,
    InProgress: 2,
    Uploaded: 3,
    Error: 4
};
function HotfileStateFromJSON(json) {
    return HotfileStateFromJSONTyped(json, false);
}
exports.HotfileStateFromJSON = HotfileStateFromJSON;
function HotfileStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.HotfileStateFromJSONTyped = HotfileStateFromJSONTyped;
function HotfileStateToJSON(value) {
    return value;
}
exports.HotfileStateToJSON = HotfileStateToJSON;
